var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"management-tabs__container py-0 pb-16"},[_c('StatisticsFilter'),_c('StatisticsData')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }